export default __webpack_public_path__ + "static/media/screen3.3e6dc9db.png";